/**
 * URL stored on `creative.assets.links`.
 * A non-empty value is a per-creative override; otherwise the builder uses the selected event link.
 */
export function resolveCreativeDestinationUrl(
  customLink: string | undefined | null,
  eventLink: string
): string {
  const trimmed = customLink?.trim() ?? "";
  return trimmed || eventLink;
}

/** Blank, missing, or an http(s) URL. Non-strings and other URLs are rejected. */
export function isCreativeDestinationLink(link: unknown): boolean {
  if (link == null) return true;
  if (typeof link !== "string") return false;
  const trimmed = link.trim();
  if (!trimmed) return true;
  try {
    const url = new URL(trimmed);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function assertCreativeDestinationLinksOrThrow(
  creatives: ReadonlyArray<{ link?: unknown } | null | undefined>
): void {
  const invalid = creatives.some(
    (creative) => creative != null && !isCreativeDestinationLink(creative.link)
  );
  if (!invalid) return;
  throw {
    statusCode: 400,
    message: "Each creative link must be blank or an http(s) URL.",
  };
}
